import * as D from 'io-ts/Decoder';
import { WorkerError } from 'src/modules/worker/types/WorkerError';

export const WORKER_ERROR: D.Decoder<unknown, WorkerError> = D.struct({
  name: D.string,
  message: D.string,
});
